const winston = require('winston');

module.exports = (logLevel, transports) => {
    const options = {
        transports,
        level: logLevel,
        colorize: true,
        meta: false
    };

    return winston.createLogger(options);
};
